import React, { useContext, useState } from 'react'
import './CSS/ShopCategory.css'
import { ShopContext } from '../Context/ShopContext'
import Item from '../Components/Items/Item'

const ShopCategory = (props) => {

  const { all_product } = useContext(ShopContext)

  const isAccounts = props.category === 'accounts'

  const [vpRegion, setVpRegion] = useState('ind')

  return (
    <div className='shop-category'>

      <div className='shopcategory-header'>

        <div className='shopcategory-tag'>
          BADTAMEEZDIL GAMESTORE
        </div>

        <h1>
          {isAccounts ? 'Valorant Accounts' : 'Valorant VP'}
        </h1>

        <p>
          {isAccounts
            ? 'Browse premium Valorant accounts and find the perfect account for you.'
            : 'Choose your Valorant VP package and level up your game.'
          }
        </p>

      </div>

      {!isAccounts && (
        <div className='vp-section-title'>

          <h2>Valorant VP Packages</h2>

          <div className='vp-tabs'>
            <button
              className={vpRegion === 'ind' ? 'vp-tab active' : 'vp-tab'}
              onClick={() => setVpRegion('ind')}
            >
              IND VP
            </button>

            <button
              className={vpRegion === 'php' ? 'vp-tab active' : 'vp-tab'}
              onClick={() => setVpRegion('php')}
            >
              PHP VP
            </button>
          </div>

          <div className='vp-line'></div>

        </div>
      )}

      <div className='shopcategory-products'>

        {all_product.map((item, i) => {

          const shouldShow =
            props.category === 'accounts'
              ? item.category === 'accounts'
              : item.category === 'vp' && item.region === vpRegion

          if (shouldShow) {

            return (
              <Item
                key={i}
                id={item.id}
                name={item.name}
                image={item.image}
                new_price={item.new_price}
                old_price={item.old_price}
              />
            )

          }

          return null
        })}

      </div>

    </div>
  )
}

export default ShopCategory